import React from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import { ErrorMessage, Button, RequiredMark } from "components";
import { useExperianClearFraudMutation } from "queries";
import { uiActions } from "store";
import { required } from "validators/validation";

import CloseButton from "../closeButton";

import styles from "./modal.module.scss";

const ExperianCheckListModal = ({
	show,
	onHide,
	dialogAs,
	backdrop,
	applicationId,
	ownerType,
	refetchDataExperianOwner,
}) => {
	const {
		register,
		handleSubmit,

		formState: { errors },
	} = useForm({
		mode: "onChange",
		reValidationMode: "onChange",
	});

	const dispatch = useDispatch();

	const {
		mutateAsync: clearFraudAlert,
		isLoading: isLoadingClearFraudAlert,
	} = useExperianClearFraudMutation();

	const handleReport = ({ note }) => {
		dispatch(uiActions.showSpinnerOverlay());
		clearFraudAlert({
			applicationId,
			ownerType,
			notes: note,
			onSuccessHandler: () => {
				refetchDataExperianOwner?.();
				onHide();
			},
		}).finally(() => dispatch(uiActions.hideSpinnerOverlay()));
	};

	return (
		<Modal
			show={show}
			onHide={onHide}
			animation={false}
			centered
			dialogAs={dialogAs}
			backdrop={backdrop}
			size="lg"
			className={styles.wrappExperianCheckListModal}
		>
			<Modal.Header className={styles.header}>
				<Modal.Title className={styles.title}>
					Are you sure you want to clear fraud alert?
				</Modal.Title>
				<CloseButton onClick={onHide} />
			</Modal.Header>
			<Modal.Body className={styles.body}>
				<form onSubmit={handleSubmit(handleReport)}>
					<div className={styles.wrappNotes}>
						<div className={styles.notes}>
							<p>
								Notes
								<RequiredMark />
							</p>
							<textarea
								{...register("note", {
									validate: {
										required,
									},
								})}
								className={errors.note && "error-border"}
							/>
							<ErrorMessage field="note" errors={errors} />
						</div>
					</div>
					<div className={styles.wrappReportBtn}>
						<Button
							onClick={onHide}
							value="Cancel"
							variant="outline-primary"
							style={{ marginRight: "30px" }}
						/>
						<Button
							type="submit"
							value="Clear"
							disabled={isLoadingClearFraudAlert}
						/>
					</div>
				</form>
			</Modal.Body>
		</Modal>
	);
};

export default ExperianCheckListModal;
